import { Service, inject } from '@piwikpro/platform';
import { Interceptable, IRequest, NextFunction } from '@piwikpro/http-crate/interfaces';
import { Notifications } from '@piwikpro/notification-crate';

@Service()
export class MaintenanceInterceptor implements Interceptable {
  constructor(
    @inject('NotificationCrate.notifications') private readonly notifications: Notifications,
  ) {}

  async intercept<T>(req: Required<IRequest<T>>, next: NextFunction): Promise<T> {
    let resp;

    try {
      resp = await next(req);
    } catch (err: any) {
      const maintenanceModeEnabled = err.headers?.get('X-Reason') === 'maintenance-mode';
      if (err.name === 'ServiceUnavailableError' && maintenanceModeEnabled) {
        this.notifications.push({
          id: 'MaintenanceModeNotification',
          text: 'components:maintanancemodeMsg',
          type: 'error',
          autoCloseSeconds: 5,
        });
      }

      throw err;
    }

    return resp;
  }
}
